import { lazy, Suspense, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// components
import LoadingScreen from './components/loading-screen';
// routes
import Router from './routes';

// Lazy load MUI providers only when needed
const MUIProviders = lazy(() => import('./MUIProviders'));

// ----------------------------------------------------------------------

export default function AppWrapper() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  // Load appropriate CSS and fonts based on route
  useEffect(() => {
    if (isHomePage) {
      import('./home.css');
    } else {
      import('./index.css');
      
      // Load additional fonts for non-homepage routes
      const fontId = 'additional-fonts';
      if (!document.getElementById(fontId)) {
        const additionalFonts = document.createElement('link');
        additionalFonts.id = fontId;
        additionalFonts.rel = 'stylesheet';
        additionalFonts.href = 'https://fonts.googleapis.com/css2?family=Orbitron&family=Poppins:wght@400;500;600;700;800&family=Barlow:wght@100;200;300;400;500;600;700;800;900&display=swap';
        document.head.appendChild(additionalFonts);
      }
    }
  }, [isHomePage]);

  // Home page: no MUI, minimal CSS
  if (isHomePage) {
    return <Router />;
  }

  // All other routes: full MUI + CSS
  return (
    <Suspense fallback={<LoadingScreen />}>
      <MUIProviders>
        <Router />
      </MUIProviders>
    </Suspense>
  );
}
